import { log } from '#/utils/logging';

export function validateEvent(
  eventName: string,
  properties: Record<string, unknown>,
) {
  const isValidEventName =
    !eventName.includes('_') && /^[A-Z0-9]/.test(eventName);
  if (!isValidEventName) {
    log.error(`Invalid Analytics event name: "${eventName}"`);
  } else {
    const invalidPropertyName = Object.keys(properties).find((name) => {
      const isValid = /^[a-z0-9_]+$/.test(name);
      return !isValid;
    });

    if (invalidPropertyName) {
      log.error(
        `Invalid Analytics property name: "${invalidPropertyName}". Property names must be snake case`,
      );
    }
  }
}
